import React, { useRef, useState } from 'react'
import { useStateValue } from '../../../StateProvider';
import { getDefaultValue, getExtension, isYoutube, Mg } from '../../../utils';
import {
  uploadTalentVideoToFirebase,
} from '../../../utils/Network';
import { ContestHttpService } from '../../../utils/http/contest_http_service';

function UploadDocumentForm({ talentId, max_file_size = 20 * 1024 * 1024, step = 0, onSuccess, onCancel, userDocumentId = 0 }) {

    const [userDocument, setUserDocument] = useState(null);
    const [userDocumentUrl, setUserDocumentUrl] = useState(null);
    const [uploading, setUploading] = useState(false);
    const [upload_modal_error, setUploadModalError] = useState(false);
    const [progress, setProgress] = useState(0);
    const [upload_error, setUploadError] = useState(false);
    const [uploadFileName, setUploadFileName] = useState("");

    const [{ translations }] = useStateValue();
    const upload_enabled = true;
    var allowed_extensions = "mp4,mpeg4,mov";
    const inputFileRef = useRef(null);

    const handleTextChange = (e) => {
        switch (e.target.name) {
            case "document_url":
                setUserDocumentUrl(e.target.value);
                break;

            default:
                break;
        }
    };

    const handleFileChange = (e) => {
        var selectedFiles = e.target.files;

        if (selectedFiles.length) {
            let ext = getExtension(selectedFiles[0].name);
            let file_size = selectedFiles[0].size;
            if (file_size >= max_file_size + 1) {
                setUploadError(
                    "it seems that your file is too big. Maximum allowed file size is " +
                    Mg(max_file_size) +
                    " MB"
                );
            } else {
                if (allowed_extensions && allowed_extensions.split(",").includes(ext)) {
                    if (allowed_extensions.split(",").includes("mp4")) {
                        uploadTalentVideo(selectedFiles[0]).then(() => {});
                    }
                } else {
                    setUploadError(
                        "This document type is not allowed. allowed types :" +
                        allowed_extensions
                    );
                }
            }
        }
    };

    const VIDEO_UPLOAD_ERROR =
        "Video upload failed. Please try again later.";

    async function uploadTalentVideo(file) {
        setUploadError(false);
        setUploading(true);
        setUploadFileName(file?.name || "");
        setProgress(0);
        const result = await uploadTalentVideoToFirebase(file, (p) => setProgress(p));
        if (result.ok && result.public_url) {
            setProgress(100);
            saveUserDocumentUrl(result.public_url);
        } else {
            setUploading(false);
            setUploadFileName("");
            setProgress(0);
            setUploadError(result.error || VIDEO_UPLOAD_ERROR);
        }
    }

    const saveUserDocumentUrl = (url) => {
        if (!url) {
            setUploadModalError("Please Enter the url");
            return;
        }


        setUploadModalError(false);
        setUploading(true);

        var body = {
            "id" : userDocumentId,
            "talent": talentId,
            "url": url
        }

        ContestHttpService.saveUsertalentDocument(body)
            .then((response) => {
                if (response.Error) setUploadModalError(response.Error);
                else {
                    setUserDocument(response);
                    response.courses = "[]"
                    if (onSuccess) {
                        onSuccess(response)
                    }
                }
            })
            .catch(() => setUploadModalError(VIDEO_UPLOAD_ERROR))
            .finally(() => {
                setUploading(false);
                setUploadFileName("");
            });
    };


    const translate = (str) => {
        if (!translations) return str;
        var translate = translations.find(x => x.key === str);

        if (translate) return getDefaultValue(translate);
        else return str;
    };

    const selectFile = () => {
        inputFileRef.current.click();
        // setUploadModalOpen(false);
    };

    return (
        <div className="row document-upload-container">
            {upload_enabled && (
                <div className="col-md-12 text-center mb-3 mt-3  ">
                    <div className="document-upload-container__header">
                        <span aria-hidden="true" />
                        {allowed_extensions.split(",").includes("mp4") ? (
                            <h2>{translate("Upload your video")}</h2>
                        ) : (
                            <p>{translate("Upload your document here")}</p>
                        )}
                        {typeof onCancel === "function" ? (
                            <button
                                type="button"
                                className="document-upload-container__cancel kfont"
                                onClick={onCancel}
                                disabled={uploading}
                            >
                                <i className="fas fa-times mr-2" aria-hidden="true" />
                                {translate("Cancel")}
                            </button>
                        ) : (
                            <span aria-hidden="true" />
                        )}
                    </div>

                    <input
                        type="file"
                        ref={inputFileRef}
                        name="upload_file"
                        className="hide"
                        onChange={handleFileChange}
                    />

                    <div className="video-source-options">
                        <section className={`video-source-option video-source-option--device${uploading ? " video-source-option--uploading" : ""}`}>
                            {uploading ? (
                                <div
                                    className={`video-upload-status${uploadFileName ? "" : " video-upload-status--saving"}`}
                                    role="status"
                                    aria-live="polite"
                                    aria-busy="true"
                                >
                                    <div className="video-upload-status__topline">
                                        <span className="video-upload-status__icon" aria-hidden="true">
                                            <i className={progress >= 100 ? "fas fa-check" : "fas fa-arrow-up"} />
                                        </span>
                                        <div className="video-upload-status__copy">
                                            <strong>
                                                {progress >= 100
                                                    ? translate("Finalizing your video...")
                                                    : translate("Uploading your video...")}
                                            </strong>
                                            {uploadFileName && <span title={uploadFileName}>{uploadFileName}</span>}
                                        </div>
                                        {uploadFileName && (
                                            <span className="video-upload-status__percent">
                                                {Math.min(100, Math.max(0, Math.round(progress)))}%
                                            </span>
                                        )}
                                    </div>
                                    <div
                                        className={`video-upload-status__track${uploadFileName ? "" : " video-upload-status__track--indeterminate"}`}
                                        role="progressbar"
                                        aria-valuemin="0"
                                        aria-valuemax="100"
                                        aria-valuenow={uploadFileName ? Math.round(progress) : undefined}
                                    >
                                        {uploadFileName && (
                                            <span style={{ transform: `scaleX(${Math.min(100, Math.max(0, progress)) / 100})` }} />
                                        )}
                                    </div>
                                    <p>{translate("Keep this window open until the upload is complete.")}</p>
                                </div>
                            ) : (
                                <>
                            <span className="video-source-option__icon" aria-hidden="true">
                                <i className="fas fa-arrow-up" />
                            </span>
                            <div className="video-source-option__copy">
                                <span className="video-source-option__eyebrow">{translate("Upload file")}</span>
                                <h3>{translate("From your device")}</h3>
                                <p>{translate("Choose a video saved on your phone or computer.")}</p>
                            </div>
                            <button
                                type="button"
                                className="video-source-option__action"
                                disabled={uploading}
                                onClick={selectFile}
                            >
                                <i className="fas fa-folder-open" aria-hidden="true" />
                                {translate("Choose video")}
                            </button>
                            <div className="video-source-option__meta" aria-label={translate("Upload limits") }>
                                <span>{Mg(max_file_size)} MB max</span>
                                {allowed_extensions.split(",").map((extension) => (
                                    <span key={extension}>{extension.trim().toUpperCase()}</span>
                                ))}
                            </div>
                            {upload_error && (
                                <div className="video-source-option__error" role="alert">{upload_error}</div>
                            )}
                                </>
                            )}
                        </section>

                        {allowed_extensions.split(",").includes("mp4") && (
                            <section className="video-source-option video-source-option--youtube">
                                <span className="video-source-option__icon" aria-hidden="true">
                                    <i className="fab fa-youtube" />
                                </span>
                                <div className="video-source-option__copy">
                                    <span className="video-source-option__eyebrow">{translate("Use a link")}</span>
                                    <h3>{translate("From YouTube")}</h3>
                                    <p>{translate("Paste the public link to your video.")}</p>
                                </div>
                                <div className="video-source-option__url">
                                    <input
                                        type="url"
                                        name="document_url"
                                        value={userDocumentUrl || ""}
                                        onChange={handleTextChange}
                                        className="form-control ltr"
                                        placeholder="https://youtube.com/watch?v=..."
                                        aria-label={translate("YouTube video URL")}
                                    />
                                    <button
                                        type="button"
                                        disabled={uploading}
                                        onClick={() => {
                                            if (!isYoutube(userDocumentUrl)) {
                                                setUploadModalError("Please enter a valid YouTube URL");
                                                return;
                                            }
                                            saveUserDocumentUrl(userDocumentUrl)
                                        }}
                                    >
                                        {translate("Use this link")}
                                    </button>
                                </div>
                                {upload_modal_error && (
                                    <div className="video-source-option__error" role="alert">{upload_modal_error}</div>
                                )}
                            </section>
                        )}
                    </div>

                </div>
            )}
        </div>
    )
}

export default UploadDocumentForm
